import React from 'react';
import { Section } from 'new/components/settings/VendorBuilder/components/Section';
import { TextField } from 'new/elements/TextField';
import { useVendorBuilder } from 'new/components/settings/VendorBuilder/VendorBuilderContext';
import { Checkbox, FormControlLabel } from '@mui/material';
import { JWTFields } from 'new/components/settings/VendorBuilder/AuthConfig/AdvancedTemplateConfig/JWTFields';
import { HMACFields } from 'new/components/settings/VendorBuilder/AuthConfig/AdvancedTemplateConfig/HMACFields';
import { CertSignedFields } from 'new/components/settings/VendorBuilder/AuthConfig/AdvancedTemplateConfig/CertSignedFields';
import Typography from 'new/elements/Typography';
interface AdvancedProps {
  templateIndex: number;
}

export const AdvancedTemplateConfig = (props: AdvancedProps) => {
  const { templateIndex: index } = props;
  const { vendor, onChange } = useVendorBuilder();
  const config = vendor?.auth_templates[index]?.config ?? {};
  return (
    <Section
      title={<div>Template #{index + 1}: Advanced Rest Config Params (Optional) </div>}
      gap="16px"
    >
      <Typography variant="body2">
        In really rare occasions you might need some settings like JWT, HMAC, certificates, etc.
        These are available in Nexla UI in the <strong>Advanced</strong> section of{' '}
        <strong>Rest Credential Screen</strong>.
        <br />
        Apply settings fromt this section if and when needed. These properties are similar to any
        other credential config params, just broken out in different section because they are rarely
        used.
      </Typography>
      <TextField
        fullWidth
        label={
          <Typography variant="body2">
            Additional Request Headers{' '}
            <code>auth_templates[{index}].config["request.headers"]</code>
          </Typography>
        }
        helperText="Add any additional request headers that must be sent as part of every request. Please input these headers as comma-separated values. E.g., header1:value1,header2:value2."
        name={`auth_templates[${index}].config["request.headers"]`}
        onChange={onChange}
      />
      <FormControlLabel
        onChange={onChange}
        control={
          <Checkbox name={`auth_templates[${index}].config["ignore.ssl.cert.validation"]`} />
        }
        label={
          <Typography variant="body2">
            Ignore SSL certificate validation?{' '}
            <code>auth_templates[{index}].config["ignore.ssl.cert.validation"]</code>
          </Typography>
        }
      />
      <FormControlLabel
        onChange={onChange}
        control={<Checkbox name={`auth_templates[${index}].config["jwt.enabled"]`} />}
        label={
          <Typography variant="body2">
            Enable JWT Authentication? <code>auth_templates[{index}].config["jwt.enabled"]</code>
          </Typography>
        }
      />
      {config['jwt.enabled'] ? <JWTFields index={index} /> : null}
      <FormControlLabel
        onChange={onChange}
        control={<Checkbox name={`auth_templates[${index}].config["hmac.enabled"]`} />}
        label={
          <Typography variant="body2">
            Enable HMAC Signature Based Authentication?
            <code>auth_templates[{index}].config["hmac.enabled"]</code>
          </Typography>
        }
      />
      {config['hmac.enabled'] ? <HMACFields index={index} /> : null}
      <FormControlLabel
        onChange={onChange}
        control={<Checkbox name={`auth_templates[${index}].config["ui.cert_signed"]`} />}
        label={
          <Typography variant="body2">
            Sign Requests with Certificates?{' '}
            <code>auth_templates[{index}].config["ui.cert_signed"]</code>
          </Typography>
        }
      />
      {config['ui.cert_signed'] ? <CertSignedFields index={index} /> : null}
    </Section>
  );
};
